import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "../src/sass/style.scss";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastProvider } from "./context/ToastContext";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();